import { render, staticRenderFns } from "./CarRequests.vue?vue&type=template&id=bea98cc0&scoped=true"
import script from "./CarRequests.vue?vue&type=script&lang=js"
export * from "./CarRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea98cc0",
  null
  
)

export default component.exports